import PropTypes from 'prop-types';
import { TableBody, TableRow } from '@mui/material';
import StyledTableCell from 'components/SummaryComponent/StyledTableCell';
import { formatDate } from 'utils/date';

function CardAccommodationComponent({ accommodation, bedroom, dateParams }) {
  return (
    <TableBody>
      {accommodation?.accommodationName?.name && (
        <TableRow>
          <StyledTableCell component="th" scope="row">
            Nome
          </StyledTableCell>
          <StyledTableCell align="right">
            {accommodation?.accommodationName?.name}
          </StyledTableCell>
        </TableRow>
      )}
      <TableRow>
        <StyledTableCell component="th" scope="row">
          Tipo
        </StyledTableCell>
        <StyledTableCell align="right">
          {accommodation.typeName}
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell component="th" scope="row">
          Quarto
        </StyledTableCell>
        <StyledTableCell align="right">{bedroom}</StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell component="th" scope="row">
          Alimentação
        </StyledTableCell>
        <StyledTableCell align="right">
          {accommodation.mealName}
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell component="th" scope="row">
          Data de entrada
        </StyledTableCell>
        <StyledTableCell align="right">
          {formatDate(dateParams.accommodationStart, 'forward-slash')}
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell component="th" scope="row">
          Data de saída
        </StyledTableCell>
        <StyledTableCell align="right">
          {formatDate(dateParams.accommodationEnd, 'forward-slash')}
        </StyledTableCell>
      </TableRow>
    </TableBody>
  );
}

CardAccommodationComponent.propTypes = {
  accommodation: PropTypes.instanceOf(Object).isRequired,
  bedroom: PropTypes.string.isRequired,
  dateParams: PropTypes.instanceOf(Object).isRequired,
};

export default CardAccommodationComponent;
